const Styles = {
    'spinner': 'TriBarPulseSpinner_spinner--c7312eb7 base_container--330154d1',
    'bars': 'TriBarPulseSpinner_bars--15884f17 base_layer--83e929aa'
};

export default Styles;